// Maps upload error_code values (utils/s3_helpers.py upload_file_to_r2)
// to user-actionable copy. Fall back to the server's message, then to a
// caller-supplied generic. Branch on error_code — never string-match the
// message (CLAUDE.md "Structured Error Codes from Utilities").

const UPLOAD_ERROR_COPY = {
    FILE_TOO_LARGE: 'That file is over the size limit. Try a smaller photo.',
    IMAGE_TOO_LARGE: "That image's dimensions are too large to process. Try exporting a smaller version.",
    HEIC_DECODE_FAILED: "We couldn't read that HEIC photo. Try exporting it as JPEG and uploading again.",
    INVALID_FILE_TYPE: "That file type isn't supported. Use a JPEG, PNG, GIF, WebP, or HEIC photo.",
    INVALID_CONTENT: "That file doesn't look like a valid image. Try re-exporting it.",
    NO_FILE_PROVIDED: 'No file was selected.',
    NO_FILE_SELECTED: 'No file was selected.',
    NO_EXTENSION: 'That file has no extension, so we can\'t tell what type it is.',
    R2_NOT_CONFIGURED: "Image storage isn't available right now. Please try again later.",
    // Storage is configured but rejects the server's credentials (rotated
    // secret, wrong bucket). Same user-facing situation as not configured:
    // nothing to fix on their end, so the same copy — never the server's
    // generic "try again" text, which reads as a flaky connection.
    R2_MISCONFIGURED: "Image storage isn't available right now. Please try again later.",
    R2_UPLOAD_FAILED: "The upload didn't go through. Check your connection and try again.",
};

/**
 * @param {{error_code?: string, message?: string}} err - thrown service error
 * @param {string} fallback - generic copy when neither code nor message helps
 * @returns {string} user-facing message
 */
export const uploadErrorMessage = (err, fallback = 'Failed to upload file.') =>
    UPLOAD_ERROR_COPY[err?.error_code] || err?.message || fallback;
